import type { ComponentProps } from 'react';
import { DocumentHistoryDrawer as DocumentHistoryDrawerCore } from './core/components/DocumentHistoryDrawer';
import type { ActivityAdapter } from './core/model';
import {
  documentChangesAdapter,
  documentOpenedAdapter,
} from './features/document-changes';
import { fieldChangesAdapter } from './features/field-changes';

// Registry composed at the module edge — core/ stays free of feature imports
// (enforced by the module-boundaries dependency rules). Each adapter also
// provides the renderer for its rows. A block lists its rows in this order;
// the display is newest-first and opening precedes the session's edits, so
// the opened adapter goes last.
const ADAPTERS: ActivityAdapter[] = [
  fieldChangesAdapter,
  documentChangesAdapter,
  documentOpenedAdapter,
];

type DocumentHistoryDrawerProps = Omit<
  ComponentProps<typeof DocumentHistoryDrawerCore>,
  'adapters'
>;

export const DocumentHistoryDrawer = (props: DocumentHistoryDrawerProps) => (
  <DocumentHistoryDrawerCore {...props} adapters={ADAPTERS} />
);
